export default __webpack_public_path__ + "static/media/y.e6cb1150.png";